<template>
  <div class="social-wrapper">
    <ShareNetwork
      v-if="deviceType === 'ios'"
      network="sms"
      :url="url"
      :title="smsIOS"
      @open="$emit('close')"
    >
      <img  width="32" height="32" src="../assets/mail-black.png" alt="" class="icon">
      <p>{{ $t("socialMedia.text") }}</p>
    </ShareNetwork>
    <ShareNetwork
      v-if="deviceType === 'android' || deviceType === ''"
      network="sms"
      :url="url"
      :title="sms"
      @open="$emit('close')"
    >
      <img  width="32" height="32" src="../assets/mail-black.png" alt="" class="icon">
      <p>{{ $t("socialMedia.text") }}</p>
    </ShareNetwork>
    <ShareNetwork
      network="email"
      :url="url"
      :title="title"
      :description="description"
      @open="$emit('close')"
    >
      <img  width="32" height="32" src="../assets/vt-at.svg" alt="" class="icon">
      <p>{{ $t("socialMedia.email") }}</p>
    </ShareNetwork>
    <ShareNetwork
      network="facebook"
      :url="url"
      :title="title"
      :description="description"
      @open="$emit('close')"
    >
      <img  width="32" height="32" src="../assets/vt-facebook.svg" alt="" class="icon fb-icon">
      <p>{{ $t("socialMedia.facebook") }}</p>
    </ShareNetwork>
    <ShareNetwork
      network="twitter"
      :url="url"
      :title="truncate(`Exploring ${title} through VisiTOUR`)"
      @open="$emit('close')"
    >
      <img  width="32" height="32" src="../assets/vt-twitter.svg" alt="" class="icon twitter-icon">
      <i class="fa fa-facebook" role="presentation"></i>
      <p>{{ $t("socialMedia.twitter") }}</p>
    </ShareNetwork>
    <button class="close-share desktop-visible" @click="$emit('close')" aria-label="Close share popup">
      <i class="material-icons" aria-hidden="true">close</i>
    </button>
  </div>
</template>

<script>

export default {
  name: 'ShareBlock',
  props: ['url', 'title', 'description'],
  data: function () {
    return {
      deviceType: '',
      smsIOS: `I'm looking at ${this.title.replace(/&/g, '%20%26%20')} at ${this.$store.state.college.name} with VisiTOUR. Join me at ${this.url}`,
      sms: `I'm looking at ${this.title.replace(/&/g, 'and')} at ${this.$store.state.college.name} with VisiTOUR. Join me at ${this.url}`
    }
  },
  created () {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera
    if (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i) || userAgent.match(/iPod/i)) {
      this.deviceType = 'ios'
    } else if (userAgent.match(/Android/i)) {
      this.deviceType = 'android'
    }
  },
  watch: {
    title: function (val) {
      this.smsIOS = `I'm looking at ${val.replace(/&/g, '%20%26%20')} at ${this.$store.state.college.name} with VisiTOUR. Join me at ${this.url}`
      this.sms = `I'm looking at ${val.replace(/&/g, 'and')} at ${this.$store.state.college.name} with VisiTOUR. Join me at ${this.url}`
    }
  },
  methods: {
    truncate: function (input) {
      if (input.length > 230) {
        return input.substring(0, 230) + '...'
      } else {
        return input
      }
    }
  }
}
</script>
